module.exports = __webpack_public_path__ + "static/toodledo-50005e92317b01c5506f74fb98af3d20.png";